<!--
 * @Descripttion: 
 * @version: 
 * @Author: tangyuan
 * @Date: 2020-11-30 17:23:01
 * @LastEditors: tangyuan
 * @LastEditTime: 2020-12-04 16:22:04
-->
<template>
    <div class="more" @click="goPage">
        <span>{{span}}</span><span>></span>
    </div>
</template>

<script>
    export default {
        props:['span'],
        name:'MoreIndex',
        methods: {
            goPage() {
                this.$emit('goPage')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .more{
        cursor: pointer;
        height: 24px;
        line-height: 24px;
        width: 100%;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        span{
            margin: 0 10px;
        }
    }
</style>